'use strict';
require('../../modules/esnext.object.iterate-keys');
var path = require('../../internals/path');

module.exports = path.Object.iterateKeys;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/full/object/iterate-keys.js
// module id = 365
// module chunks = 0